import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import CollectionsBookmarkIcon from '@mui/icons-material/CollectionsBookmark';
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from '../../../config/constants';
import {
	COLOR_DRAWER_ICON_MY_PATTERNS,
	COLOR_DRAWER_ITEM_HOVER,
	COLOR_DRAWER_ITEM_TEXT,
} from '../../../styles/tokens';

export const MyPatternsLink = ({ callBack }) => {
	const navigate = useNavigate();
	const location = useLocation();

	if (location.pathname.toLowerCase() === ROUTES.MY_PATTERNS.toLowerCase())
		return null;

	const handleClick = () => {
		callBack();
		navigate(ROUTES.MY_PATTERNS);
	};

	return (
		<ListItem key={'MyPatterns'} disablePadding>
			<ListItemButton
				onClick={handleClick}
				sx={{ '&:hover': { backgroundColor: COLOR_DRAWER_ITEM_HOVER } }}
			>
				<ListItemIcon
					sx={{
						color: COLOR_DRAWER_ICON_MY_PATTERNS,
						minWidth: '40px',
					}}
				>
					<CollectionsBookmarkIcon />
				</ListItemIcon>
				<ListItemText
					primary={'My patterns'}
					primaryTypographyProps={{
						variant: 'h5',
						sx: { color: COLOR_DRAWER_ITEM_TEXT },
					}}
				/>
			</ListItemButton>
		</ListItem>
	);
};
